import { ElectronFunctions } from "./electron/electron";

let electronUrl:string | null = localStorage.getItem("electron-url") || null;
function initIfElectron(){
	try{
		let nativeRequire = new Function("package", "return require(package)");
		let {ipcRenderer} = nativeRequire("electron");
		let port = ipcRenderer.sendSync("request-electron-port");
		electronUrl = `http://localhost:${port}`;
		let localStorageObj = JSON.parse(ipcRenderer.sendSync("get-local-storage"));
		for (let key of Object.keys(localStorageObj)) {
			localStorage.setItem(key, localStorageObj[key]);
		}
		console.log({electronPort: electronUrl});
		requestAnimationFrame(()=>{
			ElectronFunctions.initializeElectron();
		});
	}catch(err){
		console.log("Not electron", err);
	}
}

initIfElectron();

export const BrowserInfo = {
	isFirefox() {
		return navigator.userAgent.indexOf("Firefox") != -1;
	},
	isChrome() {
		return navigator.userAgent.indexOf("Chrome") != -1;
	},
	isIE() {
		return navigator.userAgent.indexOf("MSIE") != -1;
	},
	isEdge() {
		if (this.isChrome()) {
			return false;
		}
		if (this.isFirefox()) {
			return false;
		}
		return navigator.userAgent.indexOf("Edge") != -1;
	},
	isElectron(){
		return navigator.userAgent.indexOf("Electron/") != -1;
	},
	hasElectronConfigured() {
		return electronUrl != null;
	},
	isSafari(){
		if (this.isChrome()) {
			return false;
		}
		return navigator.userAgent.toLowerCase().indexOf("safari") != -1;
	},
	isAndroid():boolean {
		return navigator.userAgent.indexOf("Android") != -1;
	},
	isIOS():boolean {
		return /iPhone|iPad|iPod/.test(navigator.userAgent);
	},
	isMobile():boolean {
		return this.isAndroid() || this.isIOS();
	},
	getElectronUrl():string{
		return electronUrl || "";
	},
	setElectronUrl(value:string){
		if (BrowserInfo.isElectron()) {
			throw new Error("This function is forbidden in the desktop app");
		}
		electronUrl = value;
		localStorage.setItem("electron-url", value);
	},
};
